<script>
export default {
  name: 'ScholarshipApplicant',
  props: {
    options: {
      required: true,
    },
  },
  data () {
    return {
      application: null,
      students: [],
      applicationFieldsToDisplay: {
        adult_count: {
          display: '# of adults',
        },
        child_count: {
          display: '# of children',
        },
        annual_income: {
          money: true,
          display: 'Annual income',
        },
        can_pay: {
          money: true,
          display: 'Can pay as much as',
        },
        non_taxable_incomes: {
          display: 'Non-taxable incomes',
          array: true,
        },
        zip_code: {
          display: 'Zip code',
        },
      },
      approveButtonCopy: 'Approve',
      counterOffer: null,
    }
  },
  computed: {
    applicant () {
      return this.options.applicant
    },
  },
  methods: {
    async getEntities () {
      this.application = (await this.$firestore.collection('scholarship_applications')
          .where('guardian_id', '==', this.applicant.id)
          .where('resolved', '==', false)
          .get())
        .docs.map(doc => doc.data())[0]
      // grab youth students if needed
      if (['youth','joint'].includes(this.application.type))
        this.students = (await this.$firestore.collection('users')
          .where('guardian_id', '==', this.applicant.id)
          .get())
        .docs.map(doc => doc.data())
      // grab adult student if needed
      if (['adult','joint'].includes(this.application.type))
        this.students.push(...(await this.$firestore.collection('users')
          .where('id', '==', this.applicant.id)
          .get())
          .docs.map(doc => doc.data())
        )
    },
    async onApprove () {
      if (this.approveButtonCopy === 'Approving...') return
      this.approveButtonCopy = 'Approving...'

      try {
        await this.$HTTP({
          method: 'put',
          uri: `users/${this.applicant.id}/scholarship-approval`,
          body: {
            origin: location.origin,
          },
        })
        this.$toast('Successfully approved application.')
        this.$modals.hide('scholarship-applicant')
      } catch (e) {
          console.error(e)
          this.$toast({
            copy: 'Could not approve user in the database.',
            class: 'alert',
          })
          this.approveButtonCopy = 'Approve'
      }
    },
    async sendCounterOffer () {
      if (!this.counterOffer) return this.$toast('Input couter offer')
      this.$toast('Sending...')
      try {
        await this.$HTTP({
          method: 'post',
          uri: `users/${this.applicant.id}/counter-offer`,
          body: {
            counterOffer: this.counterOffer,
            origin: location.origin,
          },
        })
        this.$toast('Counter offer sent.')
        this.$modals.hide('scholarship-applicant')
      } catch (e) {
        console.log(e)
        this.$toast('Could not send counter offer.')
      }
    },
  },
  mounted () {
    this.getEntities()
  },
}
</script>

<template lang="pug">
  #scholarship-applicant-main.modal-main
    .scholarship-applicant-container.modal-container
      .title Scholarship Applicant
      .content
        .application-section
          .section-title Guardian
          .application-row
            .field Name:
            .data {{applicant.name}}
          //.application-row
            .field Location ID:
            .data {{applicant.location_id}}
          //.application-row
            .field Payment type:
            .data {{applicant.payment_plan}}
          .application-row
            .field Phone:
            a.data(
              :href='`tel:${applicant.phone}`'
            ) {{applicant.phone}}
          .application-row
            .field Email:
            a.data(
              :href='`mail:${applicant.email}`'
            ) {{applicant.email}}
        .application-section(
          v-if='students.length'
        )
          .section-title Students
          template(
            v-for='student in students'
            v-if='application.student_classes[student.id]'
          )
            .application-row
              .field {{student.name}}
              .data {{student.birthday}}, {{student.ethnicity}}, {{student.gender}}
            .class-list 
              //- TODO: need to update this to get class names
              .class( 
                v-for='classId in application.student_classes[student.id]'
              ) {{classId.replace(/_/gi," ")}} 
        .application-section(
          v-if='application'
        )
          .section-title Finances
          .application-row(
            v-for='(options, key) in applicationFieldsToDisplay'
          )
            .field {{options.display}}
            .data(
              v-if='options.money'
            ) {{$toCurrency(application[key])}}
            .data(
              v-else-if='options.array'
            ) {{application[key].join(', ')}}
            .data(
              v-else
            ) {{application[key]}}
          .application-row(
            v-if='applicant.counter_offer'
          )
            .field Counter Offer
            .data {{$toCurrency(applicant.counter_offer)}}
          .application-row(
            v-if='applicant.scholarship_rebuttal'
          )
            .field Rebuttal
            .data {{applicant.scholarship_rebuttal}}
      .action
        .counter-offer-area
          .description Offer different amount
          input(
            v-model='counterOffer'
            type='number'
          )
          .button(
            @click='sendCounterOffer'
          ) Send
        .buttons-holder
          .button(
            @click='$modals.hide(`scholarship-applicant`)'
          ) Cancel
          .button(
            @click='onApprove'
          ) {{approveButtonCopy}}
</template>

<style lang="sass" scoped>
  #scholarship-applicant-main
    max-width: 360px
    .scholarship-applicant-container
      .content
        .application-section
          margin-bottom: 16px
          .section-title
            @extend .font-1-bold
            font-size: 18px
            border-bottom: thin black solid
            padding-bottom: 4px
            margin-bottom: 4px
          .application-row
            display: grid
            grid-template-columns: max-content auto
            padding: 4px 0
            .field
            .data
              justify-self: end
              text-align: right
          .email-row
            display: grid
            grid-template-columns: max-content 3rem auto
            grid-column-gap: 1rem
            margin: 1rem 0
            align-items: center
            > input
              border: none
              border-bottom: thin solid black
            .button
              cursor: pointer
              border: solid black thin
              border-radius: 1rem
              padding: .25rem
              text-align: center
          .class-list
            margin: 0.5rem 0 2rem 1rem
            text-transform: capitalize
      .action
        .counter-offer-area
          grid-template-columns: max-content 3rem auto
          grid-column-gap: 1rem
          margin-bottom: 1rem
          align-items: center
          > input
            background-color: tran
        .buttons-holder
          grid-template-columns: 1fr 1fr
          grid-column-gap: 1rem

</style>